module.exports = __webpack_public_path__ + "img/orange-stripe-lily.874f69ec.jpg";